import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import { FormControl, FormLabel, Box } from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons"; // Ícone de "X"
import "./style.scss";
import { set } from "lodash";


const CurrencyInputAlternateMM = ({
  labelName,
  input,
  center,
  readOnly,
  removeBorder,
  inputRef,
  onBlur,
  allowNegative = true,
  prefix = "R$ ",
  suffix,
  onFocus,
  className,
  classNameAdd,
  disableAllInputs,
  setSellIn,
  onChangeActive,
  onChangeSellOut,
  setSellInActive,
  customizedHandleChange
}) => {
  const myInputRef = useRef(null);
  const [value, setValue] = useState(input);

  const clearFormatting = (val) => {
    let inputValue = parseFloat(val.replace("R$ ", "").replaceAll(".", "").replace(",", "."));
    return isNaN(inputValue) ? 0 : inputValue;
  };

  function handleFocusOnLastIndex(e) {
    if (onFocus && typeof onFocus === "function") onFocus(e);
    const length = myInputRef.current.value.length;
    if (myInputRef.current.setSelectionRange) {
      myInputRef.current.setSelectionRange(length, length);
    }
  }

  const handleKeyDown = (e) => {
    const val = myInputRef.current.value;

    let { key, keyCode } = e;

    //  TRATATIVA PARA O BOTÃO DE -. EXISTENTE EM TECLADOS SAMSUNG
    if (keyCode == 229) {
      e.preventDefault();

      let newVal = clearFormatting(val);

      if (String(newVal).includes('-'))
        newVal = parseFloat(String(newVal).replace("-", ""));
      else
        newVal = parseFloat(`-${newVal}`);

      setValue(newVal);

      setTimeout(() => {
        handleFocusOnLastIndex();
      }, 1);
    }

    if (!isNaN(parseInt(key))) {
      e.preventDefault();

      const newVal = clearFormatting(val);

      let [inteiro, decimal] = String(newVal).split(".");
      const isNegativeZero = Object.is(newVal, -0);

      const firstOfDecimal = decimal?.[0] || 0;
      inteiro += firstOfDecimal;

      decimal = (decimal?.[1] || 0) + key;

      const parsedValue = parseFloat(`${isNegativeZero ? "-" : ""}${inteiro}.${decimal}`);

      setValue(parsedValue);

      setTimeout(() => {
        handleFocusOnLastIndex();
      }, 1);
    }
  };

  const handleChange = (e) => {
    const inputValue = clearFormatting(e.target.value);
    if(setSellInActive){
      setSellIn(inputValue);
    }
    setValue(inputValue);
  };

  const handleClear = () => {
    if(customizedHandleChange && typeof customizedHandleChange == "function") customizedHandleChange({ref: myInputRef, setValue: setValue});
    else setValue(""); // Limpar o valor do input
  };


  useEffect(() => {
    if(input !== 0){
      setValue(input);
    }
  }, [input]);

  useImperativeHandle(inputRef, () => myInputRef.current);

  return (
    <FormControl>
      {labelName && <FormLabel className="field__label">{labelName}</FormLabel>}
      <Box position="relative">
        <NumericFormat
          className={`bg-white currency-input-alternate search-wrapper searchWrapper currencyInput text-[1rem] ${
            center && "text-center"
          } ${removeBorder && "remove-border"}`}
          prefix={prefix}
          suffix={suffix}
          decimalScale={2}
          decimalSeparator=","
          thousandSeparator="."
          fixedDecimalScale
          allowNegative={allowNegative}
          onFocus={handleFocusOnLastIndex}
          select
          value={value}
          onKeyDown={handleKeyDown}
          onValueChange={(values) => {
            const { floatValue, formattedValue } = values;
            if(setSellInActive){
              setSellIn(floatValue);
            }
            setValue(floatValue);
            if(onChangeActive){
              onChangeSellOut(formattedValue)
            }
          }}
          readOnly={readOnly}
          getInputRef={(el) => {
            myInputRef.current = el;
          }}
          ref={inputRef}
          onBlur={onBlur}
          disabled={disableAllInputs}
        />
        {value ? (
          <Box
            as="button"
            type="button"
            position="absolute"
            right="10px"
            top="50%"
            transform="translateY(-50%)"
            onClick={handleClear}
            background="transparent"
            border="none"
            cursor="pointer"
            _hover={{ opacity: 0.8 }}
          >
            <CloseIcon color="gray.500" />
          </Box>
        ): null}
      </Box>
    </FormControl>
  );
};

export default CurrencyInputAlternateMM;
